import { Col, Row } from "antd";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import SelectComponent from "../../../components/SelectComponent";

const BannerMobileInfo = () => {
	const { bannerMobileForm, setBannerMobileForm } = useBannerMobileContext();

	let bannerPositionValue: string | null = null;
	if (bannerMobileForm.isUpper !== undefined) {
		bannerPositionValue = bannerMobileForm.isUpper ? "top" : "bottom";
	}

	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<SwitchOptionComponent
						key={"isActive"}
						title={"Aktiflik"}
						onChange={(checked) => setBannerMobileForm({ ...bannerMobileForm, isActive: checked })}
					/>
				</Col>
				<Col span={10}>
					<SwitchOptionComponent
						key={"hasNavigation"}
						title={"Yönlendirme"}
						helperText={"Banner'a tıklandığında yönlendirme yapılmasını sağlar."}
						onChange={(checked) => setBannerMobileForm({ ...bannerMobileForm, hasNavigation: checked })}
					/>
				</Col>
			</Row >
			<Row gutter={20}>
				<Col span={10}>
					<SelectComponent
						title={"Banner Konumu"}
						placeholder={"Lütfen seçiniz"}
						isRequired
						value={bannerPositionValue}
						onChange={(value) => setBannerMobileForm({ ...bannerMobileForm, isUpper: value === "top" })}
						options={[
							{ label: "Sayfa Başı", value: "top" },
							{ label: "Sayfa Sonu", value: "bottom" },
						]}
					/>
				</Col>
			</Row>
		</>
	);
};

export default BannerMobileInfo;
